import axios from "@/helpers/axios";
const commonURL = "/orders";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async pollingOrderStatus({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios({
          method: "get",
          url: `${commonURL}/biz/by-uuid/${payload}`
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async cancelOrder({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios({
          method: "post",
          url: `${commonURL}/cancel`,
          data: payload
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async submitOrders({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios({
          method: "post",
          url: `${commonURL}?&v=2`,
          data: payload
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async checkOrderStatus({ rootGetters, dispatch }) {
      try {
        await dispatch("auth/refreshSignin", null, { root: true });
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async memberOrders({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios({
          method: "get",
          url: `${commonURL}/biz-manager/member-orders?perPage=${payload.perPage}&currentPage=${payload.currentPage}`,
          data: payload
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async myOrders({ rootGetters, dispatch }, payload) {
      try {
        const encodeQ = encodeURIComponent(payload.q);
        const result = await axios({
          method: "get",
          url: `${commonURL}/biz/my?perPage=${payload.perPage}&currentPage=${payload.currentPage}&q=${encodeQ}`,
          data: payload
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async myOrdersOngoing({ rootGetters, dispatch }, payload) {
      try {
        const encodeQ = encodeURIComponent(payload.q);
        const result = await axios({
          method: "get",
          url: `${commonURL}/biz/my-ongoing?perPage=${payload.perPage}&currentPage=${payload.currentPage}&q=${encodeQ}`,
          data: payload
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async orderDetail({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios({
          method: "get",
          url: `${commonURL}/biz/${payload}`,
          data: payload
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async getUserOrderList({}, payload) {
      try {
        const result = await axios(
          `${commonURL}/biz/orders?from=${payload.from}&to=${payload.to}`
        );
        if (!result.data.success) throw result.data;
        return result.data;
      } catch (e) {
        throw e;
      }
    },
    async getMemberOrderList({}, payload) {
      try {
        const result = await axios(
          `${commonURL}/biz-manager/member/total-orders?from=${payload.from}&to=${payload.to}`
        );
        if (!result.data.success) throw result.data;
        return result.data;
      } catch (e) {
        throw e;
      }
    },
    async updateClientMemo({}, { orderId, payload }) {
      try {
        const result = await axios.patch(
          `${commonURL}/biz/${orderId}`,
          payload
        );
        return result.data;
      } catch (e) {
        throw e;
      }
    }
  },
  getters: {}
};
